module.exports = __webpack_public_path__ + "static/media/kw.ae3cbfcd.svg";